<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <v-card class="elevation-12">
                    <v-card-title>
                        Class Enrollments
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" clearable single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :search="search" :loading="enrollLoading" :sort-by="['date_time']" :sort-desc="[true]" must-sort :items-per-page="10" :headers="headers" :items="enrollments" item-key="id" class="elevation-1">
                        <template slot="item" slot-scope="props">
                            <tr>
                                <td>{{ props.item.name }} <v-btn v-if="checkDate(props.item.date_time)" color="error lighten-1" class="ml-1 px-2 py-0" small @click.stop="bookClass(props.item.id, 'remove')"><v-icon left small>cancel</v-icon>CANCEL</v-btn></td>
                                <td class="text-left">{{ props.item.date_time | moment("DD/MM/YYYY h:mm A")}}</td>
                                <td class="text-left">{{ props.item.duration }}</td>
                                <!-- <td class="text-left">{{ props.item.status | capitalize }}</td> -->
                                <td class="text-left">{{ props.item.location }}</td>
                                <td class="text-left">{{ props.item.status }}</td>
                            </tr>
                        </template>
                        <template slot="no-data">
                            <div class="justify-center align-center layout">
                                <v-icon left medium>warning</v-icon>Sorry, No enrollments Yet
                            </div>
                        </template>
                        <template slot="no-results">
                            <div class="justify-center align-center layout">
                                <v-icon left medium>warning</v-icon>Sorry, No Results found for "{{ search }}"
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from './_store';
import moment from 'moment';

export default {
    name: 'HpcEnrollModule',
    components: {
        //
    },
    data () {
        return {
            search: '',
            headers: [
                { text: 'Class', value: 'name'},
                { text: 'Date', value: 'date_time' },
                { text: 'Duration', value: 'duration' },
                { text: 'Location', value: 'location' },
                { text: 'Status', value: 'status' },
            ],
        }
    },
    computed: {
        enrollLoading(){
            return this.$store.getters['hpcenroll/enrollStatus'] == 'loading';
        },
        enrollments(){
            return this.$store.getters['hpcenroll/enrollments'];
        },
    },
    methods: {
        bookClass(class_id, action){
            this.$store.dispatch("classes/bookRequest", {class_id: class_id, class_action: action, week: 0}).then(() => {
                this.$store.dispatch('hpcenroll/hpcenrollRequest');
            });
        },
        checkDate(date_time){
            let classDate = moment(date_time);
            let curDate = moment();

            return classDate.isAfter(curDate);
        }
    },
    beforeCreate(){
        this.$store.dispatch('hpcenroll/hpcenrollRequest');
    }
};
</script>

<style scoped>
    .v-data-table td {
        height: 58px !important;
    }
</style>
